import { useEffect } from 'react';
import { Box, Grid2 as Grid, Typography } from '@mui/material';
import { InputList, TextInput, useInputHelper } from 'framework/form';
import ObjectiveInput from './ObjectiveInput';

const CategoriesInputTemplate = (props: any) => {
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);
  const source = getSource();

  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});

  useEffect(() => {
    if (!getValue()) {
      rawOnChangeCallback({
        [source]: {},
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      <TextInput source={`${source}.name`} label="Category Name" />
    </Box>
  );
};

const CostsStructureDetailsSection = () => {
  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Box>
          <>
            <Typography variant="h4" mb={2.5} color="primary">
              Categories
            </Typography>
            <InputList
              source="categories"
              inputTemplate={CategoriesInputTemplate}
              addText="Add category"
              maxFields={50}
            />
          </>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <>
          <Typography variant="h4" mb={2.5} color="primary">
            Objectives
          </Typography>
          <InputList source="objectives" inputTemplate={ObjectiveInput} addText="Add objective" maxFields={50} />
        </>
      </Grid>
    </Grid>
  );
};

export default CostsStructureDetailsSection;
